import textStyle from './legend.textStyle'
import data from './legend.data'
import pageIcons from './legend.pageIcons'
import pageTextStyle from './legend.pageTextStyle'
import emphasis from './legend.emphasis'
import selectorLabel from './legend.selectorLabel'

export default {
  name: "legend",
  nickname: "图例",
  desc: "legend",
  type: "object",
  props: {
    type: {
      name: "type",
      nickname: "类型",
      desc: "图例的类型。可选值：",
    },
    show: {
      name: "show",
      nickname: "显示",
      desc: "show",
      value: true,
      defaultValue: true,
      type: "pureValue",
    },
    zlevel: {
      name: "zlevel",
      nickname: "图形z水平",
      desc: "所有图形的 zlevel 值。",
      value: 0,
      defaultValue: 0,
    },
    z: {
      name: "z",
      nickname: "z",
      desc:
        '组件的所有图形的<code class="codespan">z</code>值。控制图形的前后顺序。<code class="codespan">z</code>值小的图形会被<code class="codespan">z</code>值大的图形覆盖。',
      value: 2,
      defaultValue: 2,
      type: "pureValue",
    },
    left: {
      name: "left",
      nickname: "位置左",
      desc: "图例组件离容器左侧的距离。",
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    top: {
      name: "top",
      nickname: "位置上",
      desc: "图例组件离容器上侧的距离。",
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    right: {
      name: "right",
      nickname: "位置右",
      desc: "图例组件离容器右侧的距离。",
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    bottom: {
      name: "bottom",
      nickname: "位置下",
      desc: "图例组件离容器下侧的距离。",
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    width: {
      name: "width",
      nickname: "宽度",
      desc: "图例组件的宽度。默认自适应。",
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    height: {
      name: "height",
      nickname: "高度",
      desc: "图例组件的高度。默认自适应。",
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    orient: {
      name: "orient",
      nickname: "布局朝向",
      desc: "图例列表的布局朝向。",
      value: "horizontal",
      defaultValue: "horizontal",
      type: "pureValue",
    },
    align: {
      name: "align",
      nickname: "对齐",
      desc:
        '图例标记和文本的对齐。默认自动，根据组件的位置和 orient 决定，当组件的 <a target="__blank" href="https://echarts.apache.org/zh/option.html#legend.left">left</a> 值为 <code class="codespan">&#39;right&#39;</code> 以及纵向布局（<a target="__blank" href="https://echarts.apache.org/zh/option.html#legend.orient">orient</a> 为 <code class="codespan">&#39;vertical&#39;</code>）的时候为右对齐，即为 <code class="codespan">&#39;right&#39;</code>。',
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    padding: {
      name: "padding",
      nickname: "内边距",
      desc:
        "图例内边距，单位px，默认各方向内边距为5，接受数组分别设定上右下左边距。",
      value: 5,
      defaultValue: 5,
      type: "pureValue",
    },
    itemGap: {
      name: "itemGap",
      nickname: "间距",
      desc: "图例每项之间的间隔。横向布局时为水平间隔，纵向布局时为纵向间隔。",
      value: 10,
      defaultValue: 10,
      type: "pureValue",
    },
    itemWidth: {
      name: "itemWidth",
      nickname: "项宽度",
      desc: "图例标记的图形宽度。",
      value: 25,
      defaultValue: 25,
      type: "pureValue",
    },
    itemHeight: {
      name: "itemHeight",
      nickname: "项高度",
      desc: "图例标记的图形高度。",
      value: 14,
      defaultValue: 14,
      type: "pureValue",
    },
    symbolKeepAspect: {
      name: "symbolKeepAspect",
      nickname: "symbolKeepAspect",
      desc:
        '如果图标（可能来自系列的 <code class="codespan">symbol</code> 或用户自定义的 <code class="codespan">legend.data.icon</code>）是 <code class="codespan">path://</code> 的形式，是否在缩放时保持该图形的长宽比。',
      value: true,
      defaultValue: true,
      type: "pureValue",
    },
    formatter: {
      name: "formatter",
      nickname: "文本格式化",
      desc: "用来格式化图例文本，支持字符串模板和回调函数两种形式。",
    },
    selectedMode: {
      name: "selectedMode",
      nickname: "选择模式",
      desc:
        '图例选择的模式，控制是否可以通过点击图例改变系列的显示状态。默认开启图例选择，可以设成 <code class="codespan">false</code> 关闭。',
      value: true,
      defaultValue: true,
      type: "pureValue",
    },
    inactiveColor: {
      name: "inactiveColor",
      nickname: "关闭时颜色",
      desc: "图例关闭时的颜色。",
      value: "#ccc",
      defaultValue: "#ccc",
      type: "pureValue",
    },
    selected: {
      name: "selected",
      nickname: "选中状态",
      desc: "图例选中状态表。",
    },
    textStyle,
    tooltip: {
      name: "tooltip",
      nickname: "提示",
      desc:
        '图例的 tooltip 配置，配置项同 <a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip">tooltip</a>。默认不显示，可以在 legend 文字很多的时候对文字做裁剪并且开启 tooltip，如下示例：',
    },
    icon: {
      name: "icon",
      nickname: "图表",
      desc: "图例项的 icon。",
    },
    data,
    backgroundColor: {
      name: "backgroundColor",
      nickname: "背景色",
      desc: "图例背景色，默认透明。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    borderColor: {
      name: "borderColor",
      nickname: "边框颜色",
      desc: "图例的边框颜色。支持的颜色格式同 backgroundColor。",
      value: "#ccc",
      defaultValue: "#ccc",
      type: "pureValue",
    },
    borderWidth: {
      name: "borderWidth",
      nickname: "边框宽度",
      desc: "图例的边框线宽。",
      value: 1,
      defaultValue: 1,
      type: "pureValue",
    },
    borderRadius: {
      name: "borderRadius",
      nickname: "边框圆角",
      desc: "",
      value: 0,
      defaultValue: 0,
    },
    shadowBlur: {
      name: "shadowBlur",
      nickname: "阴影长度",
      desc:
        '图形阴影的模糊大小。该属性配合 <code class="codespan">shadowColor</code>,<code class="codespan">shadowOffsetX</code>, <code class="codespan">shadowOffsetY</code> 一起设置图形的阴影效果。',
    },
    shadowColor: {
      name: "shadowColor",
      nickname: "阴影颜色",
      desc: '阴影颜色。支持的格式同<code class="codespan">color</code>。',
    },
    shadowOffsetX: {
      name: "shadowOffsetX",
      nickname: "阴影 X",
      desc: "阴影水平方向上的偏移距离。",
      value: 0,
      defaultValue: 0,
    },
    shadowOffsetY: {
      name: "shadowOffsetY",
      nickname: "阴影 Y",
      desc: "阴影垂直方向上的偏移距离。",
      value: 0,
      defaultValue: 0,
    },
    scrollDataIndex: {
      name: "scrollDataIndex",
      nickname: "scrollDataIndex",
      desc:
        '<a target="__blank" href="https://echarts.apache.org/zh/option.html#legend.type">legend.type</a> 为 <code class="codespan">&#39;scroll&#39;</code> 时有效。',
      value: 0,
      defaultValue: 0,
    },
    pageButtonItemGap: {
      name: "pageButtonItemGap",
      nickname: "pageButtonItemGap",
      desc:
        '<a target="__blank" href="https://echarts.apache.org/zh/option.html#legend.type">legend.type</a> 为 <code class="codespan">&#39;scroll&#39;</code> 时有效。',
      value: 5,
      defaultValue: 5,
      type: "pureValue",
    },
    pageButtonGap: {
      name: "pageButtonGap",
      nickname: "pageButtonGap",
      desc:
        '<a target="__blank" href="https://echarts.apache.org/zh/option.html#legend.type">legend.type</a> 为 <code class="codespan">&#39;scroll&#39;</code> 时有效。',
    },
    pageButtonPosition: {
      name: "pageButtonPosition",
      nickname: "pageButtonPosition",
      desc:
        '<a target="__blank" href="https://echarts.apache.org/zh/option.html#legend.type">legend.type</a> 为 <code class="codespan">&#39;scroll&#39;</code> 时有效。',
      value: "end",
      defaultValue: "end",
      type: "pureValue",
    },
    pageFormatter: {
      name: "pageFormatter",
      nickname: "pageFormatter",
      desc:
        '<a target="__blank" href="https://echarts.apache.org/zh/option.html#legend.type">legend.type</a> 为 <code class="codespan">&#39;scroll&#39;</code> 时有效。',
      value: "{current}/{total}",
      defaultValue: "{current}/{total}",
      type: "pureValue",
    },
    pageIcons,
    pageIconColor: {
      name: "pageIconColor",
      nickname: "pageIconColor",
      desc:
        '<a target="__blank" href="https://echarts.apache.org/zh/option.html#legend.type">legend.type</a> 为 <code class="codespan">&#39;scroll&#39;</code> 时有效。',
      value: "#2f4554",
      defaultValue: "#2f4554",
      type: "pureValue",
    },
    pageIconInactiveColor: {
      name: "pageIconInactiveColor",
      nickname: "pageIconInactiveColor",
      desc:
        '<a target="__blank" href="https://echarts.apache.org/zh/option.html#legend.type">legend.type</a> 为 <code class="codespan">&#39;scroll&#39;</code> 时有效。',
      value: "#aaa",
      defaultValue: "#aaa",
      type: "pureValue",
    },
    pageIconSize: {
      name: "pageIconSize",
      nickname: "pageIconSize",
      desc:
        '<a target="__blank" href="https://echarts.apache.org/zh/option.html#legend.type">legend.type</a> 为 <code class="codespan">&#39;scroll&#39;</code> 时有效。',
      value: 15,
      defaultValue: 15,
      type: "pureValue",
    },
    pageTextStyle,
    animation: {
      name: "animation",
      nickname: "是否使用动画",
      desc: "图例翻页是否使用动画。",
    },
    animationDurationUpdate: {
      name: "animationDurationUpdate",
      nickname: "动画时长",
      desc: "图例翻页时的动画时长。",
      value: 800,
      defaultValue: 800,
      type: "pureValue",
    },
    emphasis,
    selector: {
      name: "selector",
      nickname: "selector",
      desc:
        "图例组件中的选择器按钮，目前包括全选和反选两种功能。默认不显示，用户可手动开启，也可以手动配置每个按钮的标题。",
      value: false,
      defaultValue: false,
    },
    selectorLabel,
    selectorPosition: {
      name: "selectorPosition",
      nickname: "selectorPosition",
      desc:
        '选择器的位置，可以放在图例的尾部或者头部，对应的值分别为 <code class="codespan">&#39;end&#39;</code> 和 <code class="codespan">&#39;start&#39;</code>。默认情况下，图例横向布局的时候，选择器放在图例的尾部；图例纵向布局的时候，选择器放在图例的头部。',
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    selectorItemGap: {
      name: "selectorItemGap",
      nickname: "selectorItemGap",
      desc: "选择器按钮之间的间隔。",
      value: 7,
      defaultValue: 7,
      type: "pureValue",
    },
    selectorButtonGap: {
      name: "selectorButtonGap",
      nickname: "selectorButtonGap",
      desc: "选择器按钮与图例组件之间的间隔。",
      value: 10,
      defaultValue: 10,
      type: "pureValue",
    },
  },
  isExpandForce: true,
  menuIconType: "text",
  menuIcon: "TL",
}
